<template>
<div id="garages-config-form">
    <v-form  v-model="validateGarageForm">
        <v-row cols="12" class="row-form d-flex flex-column p-4">
            <!-- labor hour -->
            <div class="div-spans-title">
                <span class="span-laboral">{{$t('backoffice.modules-management.scheduling.garages-config.form.labor-hour')}}</span>
                <div class="div-bottom-line">
                </div>
            </div>
            <v-col cols="12">
                <div class="d-flex" :class=" $vuetify.breakpoint.xsOnly ? 'flex-column' : 'col-divs-hour flex-row'">
                    <v-col sm="3" md="3" lg="2">
                        <v-select
                            :label="$t('backoffice.modules-management.scheduling.garages-config.open-hour-required')"
                            filled
                            v-model="garageConfig.laborHour.openHourId"
                            :rules="formRules.defaultRules"
                            :items="hourLaborDrops.map(el => ({text: el.hour, value: el.calendarHoursId}))"
                            @change="$emit('on-change-labor-hour', garageConfig.laborHour.openHourId, 'openHour')"
                            :menu-props="{ top: false, offsetY: true }"
                        ></v-select>
                    </v-col>
                    <v-col sm="3" md="3" lg="2">
                        <v-select
                            :label="$t('backoffice.modules-management.scheduling.garages-config.close-hour-required')"
                            filled
                            v-model="garageConfig.laborHour.closeHourId"
                            :rules="[closeHourRules]"
                            :items="hourLaborDrops.map(el => ({text: el.hour, value: el.calendarHoursId}))"
                            @change="$emit('on-change-labor-hour', garageConfig.laborHour.closeHourId, 'closeHour')"
                            :menu-props="{ top: false, offsetY: true }"
                        ></v-select>
                    </v-col>
                    <v-col sm="3" md="3" lg="2">
                        <v-select
                            :label="$t('backoffice.modules-management.scheduling.garages-config.start-lunch-hour-required')"
                            filled
                            v-model="garageConfig.laborHour.startLunchHourId"
                            :rules="[startLunchHourRules]"
                            :items="hourLaborDrops.map(el => ({text: el.hour, value: el.calendarHoursId}))"
                            @change="$emit('on-change-labor-hour', garageConfig.laborHour.startLunchHourId, 'startLunch')"
                            :menu-props="{ top: false, offsetY: true }"
                        ></v-select>
                    </v-col>
                    <v-col sm="3" md="3" lg="2">
                       <v-select
                            :label="$t('backoffice.modules-management.scheduling.garages-config.end-lunch-hour-required')"
                            filled
                            v-model="garageConfig.laborHour.endLunchHourId"
                            :rules="[endLunchHourRules]"
                            :items="hourLaborDrops.map(el => ({text: el.hour, value: el.calendarHoursId}))"
                            @change="$emit('on-change-labor-hour', garageConfig.laborHour.endLunchHourId, 'endLunch')"
                            :menu-props="{ top: false, offsetY: true }"
                        ></v-select>
                    </v-col>
                </div>
            </v-col>

            <!-- week days -->
            <div class="div-spans-title mt-4">
                <span class="span-laboral">{{$t('backoffice.modules-management.scheduling.garages-config.form.week-days')}}</span>
                <p>{{$t('backoffice.modules-management.scheduling.garages-config.form.week-days-subtitle')}}</p>
                <div class="div-bottom-line">
                </div>
            </div>
            <v-col cols="12">
                <v-row class="d-flex" :class=" $vuetify.breakpoint.xsOnly ? 'flex-column' : 'flex-row'" style="width: 80%;">
                    <v-col sm="3" md="3" lg="2" v-for="(day, index) in garageConfig.weekDays" :key="index">
                        <div class="d-flex flex-row">
                            <div class="d-flex flex-column">
                                <v-checkbox
                                    class="mr-4"
                                    v-model="day.value"
                                    :label="tanslateDayName(day.name)"
                                    color="primary"
                                    hide-details
                                    @click="$emit('on-change-checkbox', index, day.value)"
                                >
                                </v-checkbox>
                                <span class="span-hour-wd" v-if="day.value">{{$t('backoffice.modules-management.scheduling.garages-config.form.initials-labor-hour')}} {{transformHoursToShow(day.openHourId)}} - {{transformHoursToShow(day.closeHourId)}}</span>
                                <span class="span-hour-wd" v-if="day.value">{{$t('backoffice.modules-management.scheduling.garages-config.form.initials-lunch-time')}} {{transformHoursToShow(day.startLunchHourId)}} - {{transformHoursToShow(day.endLunchHourId)}}</span>
                            </div>
                            <span class="mr-2 p-0 circle-span-edit" @click="onEditDays(index)">
                                <img src="/images/_SVGs/bo/edit_pencil.svg" class="circle" onload="SVGInject(this)" width="12" height="12" />
                            </span>
                        </div>
                    </v-col>
                </v-row>
            </v-col>

            <!-- recurrence calendar slider -->
            <div class="div-spans-title mt-4">
                <span class="span-laboral">{{$t('backoffice.modules-management.scheduling.garages-config.form.scale-range')}}</span>
                <div class="div-bottom-line">
                </div>
            </div>
            <v-col cols="12">
                <div :style="$vuetify.breakpoint.xsOnly ? 'width: 100%' : 'width: 20%'">
                    <v-row>
                        <v-col cols="10">
                            <v-slider
                                v-model="garageConfig.scaleCalendarRange"
                                step="25"
                                ticks="always"
                                tick-size="4"
                                thumb-label
                                thumb-size="30"
                                track-color="#CDEDF9"
                            >

                                <template v-slot:thumb-label="props">
                                    {{checkSliderValues(props)}}
                                </template>

                            </v-slider>
                        </v-col>
                        <v-col cols="2">
                        {{checkSliderValues({value: garageConfig.scaleCalendarRange})}}

                        </v-col>
                    </v-row>
                </div>
            </v-col>

            <!-- extra services -->
            <div class="div-spans-title mt-4">
                <span class="span-laboral">{{$t('backoffice.modules-management.scheduling.garages-config.form.extra-services')}}</span>
                <div class="div-bottom-line">
                </div>
            </div>
            <v-col cols="12">
                <v-row
                    v-for="(service, index) in garageConfig.extraServices"
                    :key="index"
                    cols="12"
                    class="d-flex"
                    :class="$vuetify.breakpoint.xsOnly ? 'flex-column' : 'flex-row'"
                >
                    <v-col cols="12" sm="3" md="3" lg="2">
                        <v-text-field
                            :label="$t('backoffice.general.name-required')"
                            filled
                            v-model="service.name"
                            :rules="formRules.defaultRules"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3" md="3" lg="2">
                        <v-dialog
                            :ref="'dialog' + service.serviceExtraId"
                            v-model="service.dialogTime"
                            :return-value.sync="service.time"
                            persistent
                            width="290px"
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    v-model="service.time"
                                    :label="$t('backoffice.modules-management.scheduling.garages-config.execution-time-required')"
                                    append-icon="mdi-clock-time-four-outline"
                                    readonly
                                    filled
                                    v-bind="attrs"
                                    v-on="on"
                                    :rules="formRules.defaultRules"
                                ></v-text-field>
                            </template>
                            <v-time-picker
                                v-if="service.dialogTime"
                                v-model="service.time"
                                full-width
                                format="24hr"
                            >
                                <v-spacer></v-spacer>
                                <v-btn
                                    text
                                    color="primary"
                                    @click="service.dialogTime = false"
                                >
                                    {{$t('backoffice.actions.cancel')}}
                                </v-btn>
                                <v-btn
                                    text
                                    color="primary"
                                    @click="saveExtraServiceTime(service)"
                                >
                                    {{$t('backoffice.actions.ok')}}
                                </v-btn>
                            </v-time-picker>
                        </v-dialog>
                    </v-col>
                    <v-col cols="12" sm="3" md="3" lg="2">
                        <v-text-field
                            :label="$t('backoffice.general.price-required')"
                            filled
                            v-model="service.price"
                            :rules="formRules.defaultRules"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3" md="3" lg="2" class="d-flex flex-column" :class="$vuetify.breakpoint.xsOnly ? 'text-center' : ''">
                        <div class="flex-row">
                            <span @click="onDeleteExtraService(index)">
                                <img
                                    src="/images/_SVGs/bo/remove.svg"
                                    class="circle mt-4"
                                    onload="SVGInject(this)"
                                    width="12"
                                    height="12"
                                />
                            </span>
                        </div>
                    </v-col>
                    <hr v-if="$vuetify.breakpoint.xsOnly" />
                </v-row>
                <div class="mt-4" :class=" $vuetify.breakpoint.xsOnly ? 'text-center' : 'text-start'">
                    <v-btn
                        fab
                        dark
                        x-small
                        color="var(--v-primary-base)"
                        @click="onCreateExtraService"
                    >
                        <v-icon dark>
                            mdi-plus
                        </v-icon>
                    </v-btn>
                    <span @click="onCreateExtraService" class="ml-4 span-add-extra-service">{{$t('backoffice.modules-management.scheduling.garages-config.form.create-extra-service')}}</span>
                </div>
            </v-col>

        </v-row>

        <v-col cols="12" class="text-center mt-4" v-if="schedulingState.isConfigured">
            <v-btn rounded class="btn-blue" :disabled="!validateGarageForm" @click="onFinishClicked">{{$t('backoffice.modules-management.scheduling.garages-config.form.config-scheduler')}}</v-btn>
            <v-btn rounded class="btn-blue ml-6" :disabled="validateBtnExtraService" @click="onConfigExtraServicesClicked">{{$t('backoffice.modules-management.scheduling.garages-config.form.config-extra-services')}}</v-btn>
        </v-col>

        <v-col cols="12" class="text-center mt-4" v-else>
            <v-btn rounded class="btn-blue" :disabled="verifyButtonsRule" @click="onFinishClicked">{{$t('backoffice.modules-management.scheduling.garages-config.form.config-scheduler')}}</v-btn>
            <v-btn rounded class="btn-blue ml-6" :disabled="validateBtnExtraService" @click="onConfigExtraServicesClicked">{{$t('backoffice.modules-management.scheduling.garages-config.form.config-extra-services')}}</v-btn>
        </v-col>
    </v-form>

</div>
</template>

<script>

import {required} from "@src/utils/validations.js";

export default {

    props: {
        garageConfig: Array | Object,
        hourLaborDrops: Array,
        tanslateDayName: Function
    },

    data() {
        return {

            validateGarageForm: false,
            endDateRecurrence: new Date().toISOString().substr(0, 10),
            menuEndDateRecurrence: false,

            formRules: { defaultRules: [required] },

            weekDays: [
                { name: 'Segunda', value: true, id: 1 },
                { name: 'Terça', value: true, id: 2 },
                { name: 'Quarta', value: true, id: 3 },
                { name: 'Quinta', value: true, id: 4 },
                { name: 'Sexta', value: true, id: 5 },
                { name: 'Sábado', value: true, id: 6 },
                { name: 'Domingo', value: false, id: 0 },
            ],
            sliderValue: '30m',
            extraServices: [{ name: 'Lavagem Cortesia', time: '00:14', price: '6', id: 1}],
            prePayment: false,
            miminumPartValue: 0,
            schedulingState: '',
            menuTime: false,
            time: null,

        }
    },

    computed: {
        validateBtnExtraService() {
            if(this.validateGarageForm) {
                return !(this.garageConfig.extraServices && this.garageConfig.extraServices.length > 0);
            } else {
                return true;
            }
        },

        verifyButtonsRule() {
            let hasExtraServices = this.garageConfig.extraServices.length > 0;
            let hasConfiguredDays = _.some(this.garageConfig.weekDays, ['value', true]);
            let isValid = this.validateGarageForm;

            return !(hasExtraServices && hasConfiguredDays && isValid);
        }
    },

    methods: {

        saveExtraServiceTime(service) {
            const serviceRef = 'dialog' + service.serviceExtraId;
            this.$refs[serviceRef][0].save(service.time);
        },

        checkSliderValues(value) {

            switch (value.value) {
                case 0:
                    return '30m';
                    break;
                case 25:
                    return '1h';
                    break;
                case 50:
                    return '1h30';
                    break;
                case 75:
                    return '2h';
                    break;
                case 100:
                    return '2h30';
                    break;
                default:
                    '';
            }
        },

        onEditDays(dayIndex) {
            const day = this.garageConfig.weekDays[dayIndex];
            this.$emit('on-edit-days', day, day);
        },

        onCreateExtraService() {
            this.$emit('on-create-extra-service');
        },

        onDeleteExtraService(serviceIndex) {
            const service = this.garageConfig.extraServices[serviceIndex];
            this.$emit('on-delete-extra-service', service);
        },

        onFinishClicked() {
            this.$emit('on-finish-clicked', true);
        },

        onConfigExtraServicesClicked() {
            this.$emit('on-config-extra-services-clicked');
        },

        closeHourRules(value) {
            const transformClose = this.transformHours(value);
            const transformOpen = this.transformHours(this.garageConfig.laborHour.openHour);

            // First transform hours on date js
            let timeStart = new Date(transformOpen).getHours();
            let timeEnd = new Date(transformClose).getHours();

            //Pick diff hours start
            let hoursDiff = timeEnd - timeStart;
            if(hoursDiff < -1 || hoursDiff < 1) {
                 return this.$t('backoffice.modules-management.scheduling.rules.higher-entrance-hour')
            } else {
                return !!value || this.$t('backoffice.modules-management.scheduling.rules.required-field');
            }
        },

        startLunchHourRules(value) {
            const transformClose = this.transformHours(this.garageConfig.laborHour.closeHour);
            const transformOpen = this.transformHours(this.garageConfig.laborHour.openHour);
            const startLunchHour = this.transformHours(value);

            // First transform hours on date js
            let timeStart = new Date(transformOpen).getHours();
            let timeEnd = new Date(transformClose).getHours();
            let timeStartLunch = new Date(startLunchHour).getHours();

            //Pick diff hours start
            let hoursDiffClose = timeStartLunch - timeEnd;
            let hoursDiffOpen = timeStartLunch - timeStart;

            if(hoursDiffClose >= 0) {
                 return this.$t('backoffice.modules-management.scheduling.rules.less-close-hour')
            }
            if(hoursDiffOpen <= 0) {
                return this.$t('backoffice.modules-management.scheduling.rules.higher-entrance-hour')
            } else {
                return !!value || this.$t('backoffice.modules-management.scheduling.rules.required-field');
            }
        },

        endLunchHourRules(value) {
            const transformClose = this.transformHours(this.garageConfig.laborHour.closeHour);
            const transformOpen = this.transformHours(this.garageConfig.laborHour.openHour);
            const startLunchHour = this.transformHours(this.garageConfig.laborHour.startLunch);
            const endLunchHour = this.transformHours(value);

            // First transform hours on date js
            let timeStart = new Date(transformOpen).getHours();
            let timeEnd = new Date(transformClose).getHours();
            let timeStartLunch = new Date(startLunchHour).getHours();
            let timeEndLunch = new Date(endLunchHour).getHours();

            //Pick diff hours start
            let hoursDiffClose = timeEndLunch - timeEnd;
            let hoursDiffOpen = timeEndLunch - timeStart;
            let hoursDiffLunch = timeEndLunch - timeStartLunch;

            if(hoursDiffClose >= 0) {
                 return this.$t('backoffice.modules-management.scheduling.rules.less-close-hour');
            }
            if(hoursDiffOpen <= 0) {
                return this.$t('backoffice.modules-management.scheduling.rules.higher-entrance-hour')
            }
            if(hoursDiffLunch <= 0) {
                return this.$t('backoffice.modules-management.scheduling.rules.higher-lunch-time')
            } else {
                return !!value || this.$t('backoffice.modules-management.scheduling.rules.required-field');
            }
        },

        transformHours(hour) {
            let today = new Date().toISOString();
            today = today.split("T");
            return today[0] + 'T' + hour + ':00' + '.0000';
        },

        transformHoursToShow(hourId) {
            let findHourString = this.hourLaborDrops.filter(e => e.calendarHoursId == hourId);
            if(findHourString && findHourString.length > 0) {
                return findHourString[0].hour;
            } else {
                return ''
            }

        }
    },

    mounted() {
        this.schedulingState = this.$store.getters['backofficeScheduling/getStateSchedulingModule'];
    }
}
</script>

<style lang="scss" scoped>
@import "@sass/_variables.scss";
#garages-config-form {
    .valueRange{
        font-size: 12px;
        margin-left: 15px;
    }
    .div-spans-title {
        width: 100%;
            .div-bottom-line {
                border-bottom: 1px solid $grey-border-tab;
                width: 75%;
                border-bottom-width: 1px;
                margin-top: 9px;
            }
        .span-laboral {
            margin-bottom: -15px;
            font-size: 18px;
            font-weight: bold;
        }
    }

    .col-divs-hour {
        margin-bottom: -30px;
        margin-left: -10px;
    }

    .circle-span-edit {
        background-color: #E6E5E5;
        width: 20px;
        height: 0px;
        border-radius: 50%;
        display: -webkit-inline-box;
        cursor: pointer;
        margin-bottom: 6px;
        margin-top: 22px;
    }

    ::v-deep .v-label {
        margin-top: 5px;
    }

    .span-add-extra-service {
        color: var(--v-primary-base);
        cursor: pointer;
    }

    .btn-blue {
        text-transform: capitalize;
    }

    .span-hour-wd {
        margin-left: 3px;
        text-align: left;
        font: normal normal normal 10px/15px Lato;
        letter-spacing: 0px;
        color: #9E9D9D;
        opacity: 1;
    }
}
</style>
